export default function sketchSidebar(p) {
  let waves = [];
  const numWaves = 5;
  const waveHeight = 50;
  const waveSpeed = 0.02;

  p.setup = () => {
    p.createCanvas(p.windowWidth * 0.25, p.windowHeight); // Sidebar width
    for (let i = 0; i < numWaves; i++) {
      waves.push({
        offset: p.random(1000), // Random phase offset
        color: p.color(p.random(100, 255), p.random(100, 255), p.random(100, 255), 150),
      });
    }
  };

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth * 0.25, p.windowHeight);
  };

  p.draw = () => {
    p.clear(); // Clear the canvas for transparency
    p.noFill();

    waves.forEach((wave, index) => {
      p.stroke(wave.color);
      p.strokeWeight(2);

      p.beginShape();
      for (let y = 0; y <= p.height; y += 10) {
        const x = p.width / 2 + p.sin((y * 0.05) + (p.millis() * waveSpeed) + wave.offset) * waveHeight;
        p.vertex(x, y);
      }
      p.endShape();
    });
  };
}